import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransitionRecordResponseDto } from "../../shared/dtos/transitionRecord/TransitionRecordResponseDto";
import { TransitionRecordEvaluationResponseDto } from "../../shared/dtos/transitionRecord/TransitionRecordEvaluationResponseDto";
import { PaginationDto } from "../../shared/dtos/common/PaginationDto";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";

export interface TransitionRecordState {
  loadingTransitionRecords: boolean;
  loadingTransitionRecord: boolean;
  loadingEvaluation: boolean;
  loadingTransitionExecute: boolean;

  errorLoadingTransitionRecords: string | null;
  errorLoadingTransitionRecord: string | null;
  errorEvaluation: string | null;
  errorExecutingTransition: string | null;

  transitionRecords: TransitionRecordResponseDto[];
  evaluations: TransitionRecordEvaluationResponseDto[];
  transitionRecord: TransitionRecordResponseDto | null;

  serverStatus: ServerStatusPayload | null;
  pagination: PaginationDto | null;
}

const initialState: TransitionRecordState = {
  loadingTransitionRecords: false,
  loadingTransitionRecord: false,
  loadingEvaluation: false,
  loadingTransitionExecute: false,

  errorLoadingTransitionRecords: null,
  errorLoadingTransitionRecord: null,
  errorEvaluation: null,
  errorExecutingTransition: null,

  transitionRecords: [],
  evaluations: [],
  transitionRecord: null,

  serverStatus: null,
  pagination: null,
};

export const transitionRecordSlice = createSlice({
  name: "transitionRecord",
  initialState,
  reducers: {
    setLoadingTransitionRecords(state) {
      state.loadingTransitionRecords = true;
      state.errorLoadingTransitionRecords = null;
    },
    setLoadingTransitionRecord(state) {
      state.loadingTransitionRecord = true;
      state.errorLoadingTransitionRecord = null;
    },
    setLoadingEvaluation(state) {
      state.loadingEvaluation = true;
      state.errorEvaluation = null;
    },
    setLoadingTransitionExecute(state) {
      state.loadingTransitionExecute = true;
      state.errorExecutingTransition = null;
    },

    setErrorLoadingTransitionRecords(
      state,
      action: PayloadAction<string | null>,
    ) {
      state.loadingTransitionRecords = false;
      state.errorLoadingTransitionRecords = action.payload;
    },
    setErrorEvaluation(state, action: PayloadAction<string | null>) {
      state.loadingEvaluation = false;
      state.errorEvaluation = action.payload;
    },
    setErrorExecutingTransition(state, action: PayloadAction<string | null>) {
      state.loadingTransitionExecute = false;
      state.errorExecutingTransition = action.payload;
    },

    setTransitionRecords(
      state,
      action: PayloadAction<TransitionRecordResponseDto[]>,
    ) {
      state.loadingTransitionRecords = false;
      state.transitionRecords = action.payload;
    },
    setTransitionRecord(
      state,
      action: PayloadAction<TransitionRecordResponseDto>,
    ) {
      state.loadingTransitionRecord = false;
      state.transitionRecord = action.payload;
    },
    setEvaluations(
      state,
      action: PayloadAction<TransitionRecordEvaluationResponseDto[]>,
    ) {
      state.loadingEvaluation = false;
      state.evaluations = action.payload;
    },

    executeTransitionsSuccess(state) {
      state.loadingTransitionExecute = false;
      state.evaluations = [];
      state.errorExecutingTransition = null;
    },

    setServerResponseStatus(
      state,
      action: PayloadAction<ServerStatusPayload | null>,
    ) {
      state.serverStatus = action.payload;
    },
    setPagination(state, action: PayloadAction<PaginationDto>) {
      state.pagination = action.payload;
    },
    resetTransitionRecordServerStatus(state) {
      state.serverStatus = null;
    },
  },
});

export const transitionRecordActions = transitionRecordSlice.actions;
export default transitionRecordSlice.reducer;
